import { isEmpty } from "lodash";
import Lottie from "lottie-react";
import { BiPlus } from "react-icons/bi";
import animationData from "shared/assets/lotties/empty";
import Button from "shared/components/Button";

const EmptyTable = ({ message, label, onClick }) => {
  return (
    <div className={"empty__table"}>
      <div className="lottiefiles">
        <Lottie animationData={animationData} loop />
      </div>

      <h3>{message}</h3>
      {!isEmpty(onClick) && (
        <Button onClick={onClick} type={"primary"}>
          <span className="icon">
            <BiPlus size={20} />
          </span>
          <span>{label}</span>
        </Button>
      )}
    </div>
  );
};

export default EmptyTable;
